import {CsForm, makeFieldCreator} from "@Common/react/cs-form/cs-form";
import {required}                 from "@Common/react/cs-form/validators/required";
import {makeLengthValidator}      from "@Common/react/cs-form/validators/length";
import {Types}                    from "@Common/types";
import {countMatch}               from "@Common/utils/regex-util";

type FormModel = Types.Xpresso.Common.Shipping.AddressForm.Model;

export const ShippingAddressFormState = ({initValue, next}:{
    initValue ?: Partial<FormModel>,
    next       : (context:Types.Xpresso.Common.Shipping.AddressForm.StateNext) => JSX.Element,
}) => (
    CsForm({
        initValue: initValue || {countryCode: "US"},
        fields: FIELDS,
        next,
    })
);

// createField is a wrapper to assist TypeScript with field type mappings
const createField = makeFieldCreator<FormModel>();
export const FIELDS = (() => {
    const maxLength20Validator = makeLengthValidator({max: 20});
    const maxLength60Validator = makeLengthValidator({max: 60});
    const whitespaceOnly = {
        check: (str: string) => str && str.trim() !== "",
        getMessage: required.getMessage
    }
    return Array.from([
        createField({
            path: "type",
            defaultValue: "residential",
        }),
        createField({
            path: "contactName",
            validators: [required, whitespaceOnly, makeLengthValidator({max: 40})],
        }),
        createField({
            path: "company",
            validators: [
                {
                    check: (str: string, {data}) => data.type === "residential" || (Boolean(str && str.trim() !== "")),
                    getMessage: () => "Required for business addresses",
                },
                makeLengthValidator({max: 80})
            ],
        }),
        createField({
            path: "address1",
            validators: [required, whitespaceOnly, maxLength60Validator],
        }),
        createField({
            path: "address2",
            validators: [maxLength60Validator],
        }),
        createField({
            path: "city",
            validators: [required, whitespaceOnly, maxLength60Validator],
        }),
        createField({
            path: "state",
            validators: [required, maxLength20Validator],
        }),
        createField({
            path: "postalCode",
            validators: [required, whitespaceOnly, maxLength20Validator],
        }),
        createField({
            path: "plus4",
            validators: [makeLengthValidator({max: 5})]
        }),
        createField({
            path: "countryCode",
            validators: [required, maxLength20Validator],
        }),
        createField({
            path: "contactPhone",
            validators: [
                required,
                {
                    check: (str:string) => countMatch('[0-9-]', str) >= 3,
                    getMessage: () => "Please input a valid phone number",
                },
                maxLength20Validator,
            ],
        }),
        createField({
            path: "defaultBranch",
        }),
    ] as const);
})();

